import React, { Component } from 'react';
import { Button, Table } from 'reactstrap';
import { zarString, ageString, upperCaseFirstLetter } from '../../helpers/format';
import { allowedRelationships } from '../../helpers/data';

class QuoteSummary extends Component {
  constructor (props) {
    super(props);
    this.state = {
      policyholder: {},
      idType: 'id'
    };
  }

  updatePolicyholder (policyholder) {
    this.props.setData({ ...this.props.data, policyholder: { ...this.props.data.policyholder, ...policyholder } });
  }

  updateId (id) {
    this.props.setData({ ...this.props.data, policyholder: { ...this.props.data.policyholder, id: { ...this.props.data.policyholder.id, ...id } } });
  }

  getCoverAmount (member) {
    const data = this.props.data;
    switch (member.type) {
      case 'policyholder':
        return member.coverAmount;
      case 'child':
        return data.childrenCoverAmount;
      case 'spouse':
        return data.spouseCoverAmount;
      default:
        return data.extendedFamilyCoverAmount;
    }
  }

  getRelationString (member) {
    switch (member.type) {
      case 'policyholder':
        return 'You';
      case 'child':
        return 'Your child';
      case 'spouse':
        return 'Your spouse';
      default:
        const memberType = allowedRelationships.find(m => m.key === member.type);
        return memberType ? `Your ${memberType.val.toLowerCase()}` : '-';
    }
  }

  renderPremium (premium) {
    const amount = zarString(premium).replace('R', '');
    return <div className='premium'>
      <span className='currency'><b>R</b></span>
      <span className='amount'><b>{amount}</b></span>
    </div>;
  }

  renderRow (member, index) {
    const name = member.type === 'policyholder' ? 'Policyholder' : `${member.firstName} ${member.lastName}`;
    const cover = zarString(this.getCoverAmount(member));
    const age = ageString(member.dateOfBirth);
    const gender = (member.gender && upperCaseFirstLetter(member.gender)) || '-';
    const relation = this.getRelationString(member);
    return <tr key={`${member.type}-${index || ''}`}>
      <td><b>{name}</b></td>
      <td>{cover}</td>
      <td>{age}</td>
      <td>{gender}</td>
      <td>{relation}</td>
    </tr>;
  }

  renderTable () {
    const data = this.props.data;
    return <Table bordered>
      <thead>
        <tr className='table-active'>
          <th colSpan='5'>Included in quote</th>
        </tr>
      </thead>
      <tbody>
        {this.renderRow(data.policyholder)}
        {data.spouse ? this.renderRow(data.spouse) : undefined}
        {data.children.map((child, i) => this.renderRow(child, i))}
        {data.extendedFamily.map((member, i) => this.renderRow(member, i))}
      </tbody>
    </Table>;
  }

  render () {
    const data = this.props.data;
    return <div>
      <h1>Quote</h1>
      <br />
      <h5>Monthly premium</h5>
      {this.renderPremium(data.quote.suggested_premium)}
      <br />
      {this.renderTable()}

      <br />
      <br />
      <Button color='primary' className='px-5' onClick={this.props.nextStep}>Continue</Button>
      <Button color='link' onClick={this.props.previousStep}>Back</Button>
    </div>;
  }
}

export default QuoteSummary;



// WEBPACK FOOTER //
// ./src/components/application/quote-summary.js